export default __webpack_public_path__ + "82f1ad11ebecd59ee3b089e5bee43240.png";